import React from 'react'

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  note: {
    fontSize: 16,
    marginTop: 17,
    color: '#333333',
  },
}

const ConfirmableCheckboxView = ({ note, children, noteStyles = {} }) => {
  return (
    <div style={styles.wrapper}>
      <div>{children}</div>
      <div style={{ ...styles.note, ...noteStyles }}>{note}</div>
    </div>
  )
}

export default ConfirmableCheckboxView
